import React from 'react';
import { CONTACT_INFO } from '../mock';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import QuoteForm from '../components/QuoteForm';
import useSEO from '../hooks/useSEO';

const Contact = () => {
  useSEO({
    title: 'Contact Yellow, Marketing Agency Liverpool',
    description: 'Contact Yellow, a marketing agency Liverpool. Tell us about your issue or project, we\'ll come back with a proposal: creative ideas, strategy, prices and timescales.',
    path: '/contact'
  });
  return (
  <>
    <section className="pt-36 pb-14 lg:pt-44">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10">
        <p className="section-label mb-6">Contact</p>
        <h1 className="font-display text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.02] max-w-4xl">
          Let’s make something <span className="text-[#F5CD1B]">brilliant</span> together.
        </h1>
        <p className="text-white/70 text-xl leading-relaxed mt-8 max-w-3xl">
          Tell us about your issue / project and we’ll get back to you with a proposal with creative ideas, strategies, prices, timescales and next steps. Remember, we’re based in Liverpool but cover the entire UK.
        </p>
      </div>
    </section>

    <section className="py-16">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5 space-y-6">
          <InfoCard icon={Phone} label="Phone" value={CONTACT_INFO.phone} href={`tel:${CONTACT_INFO.phone.replace(/\s/g,'')}`} />
          <InfoCard icon={Mail} label="Email" value={CONTACT_INFO.email} href={`mailto:${CONTACT_INFO.email}`} />
          <InfoCard icon={MapPin} label="Studio" value={CONTACT_INFO.address} />
          <InfoCard icon={Clock} label="Hours" value={CONTACT_INFO.hours} />
        </div>

        <div className="lg:col-span-7">
          <QuoteForm source="Contact page" />
        </div>
      </div>
    </section>
  </>
  );
};

const InfoCard = ({ icon: Icon, label, value, href }) => (
  <div className="bg-[#111114] border border-white/10 rounded-2xl p-6 hover:border-[#F5CD1B]/30 transition-colors">
    <div className="flex items-start gap-4">
      <div className="w-11 h-11 rounded-lg bg-[#F5CD1B]/10 border border-[#F5CD1B]/25 flex items-center justify-center shrink-0">
        <Icon size={18} className="text-[#F5CD1B]" />
      </div>
      <div>
        <p className="section-label">{label}</p>
        {href ? (
          <a href={href} className="text-white text-lg font-semibold hover:text-[#F5CD1B] mt-1 inline-block">{value}</a>
        ) : (
          <p className="text-white text-lg font-semibold mt-1">{value}</p>
        )}
      </div>
    </div>
  </div>
);

export default Contact;
